/**
 * API Reference Errors page content.
 *
 * Documents the standard error format, all error types, and retry behavior.
 */

export const apiErrorsContent = `
All errors follow a standard format:

\`\`\`json
{
  "error": {
    "type": "not_found",
    "message": "Teammate not found",
    "code": 404,
    "request_id": "req_abc123"
  }
}
\`\`\`

## Error Types

| Status | Type | SDK Exception | Description |
|--------|------|---------------|-------------|
| 400 | invalid_request_error | APIError | Invalid request |
| 401 | authentication_error | AuthenticationError | Invalid or missing API key |
| 404 | not_found | NotFoundError | Resource not found |
| 409 | conflict_error | APIError | Resource conflict (duplicate, not active) |
| 422 | validation_error | ValidationError | Invalid request parameters |
| 429 | rate_limit_error | RateLimitError | Too many requests (auto-retried for GET/PUT/DELETE) |
| 500+ | api_error | APIError | Server error (auto-retried for GET/PUT/DELETE) |

## Automatic Retries

The Python SDK automatically retries \`429\` (rate limit) and \`500+\` (server error) responses with exponential backoff for idempotent methods (GET, PUT, DELETE). POST and PATCH are not retried to prevent duplicate side effects.

## Handling Errors

\`\`\`python
from m8tes import M8tes, NotFoundError, AuthenticationError, RateLimitError

client = M8tes()

try:
    teammate = client.teammates.get(999)
except NotFoundError:
    print("Teammate does not exist")
except AuthenticationError:
    print("Check your API key")
except RateLimitError:
    print("Too many requests - SDK will auto-retry")
\`\`\`
`;
